const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/topics/$topicId/edit.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/topics/$topicId/edit")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  remountDeps: ({
    params
  }) => [params.topicId] // remount the modal when the topicId changes
});

// Doesn't render anything, just opens the topic form modal with the given topicId